<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="outStockBills"
          @reset="resetHandle"
          @delete="deleteHandle"
          @select="selectHandle"
          @addOrEdit="addEditHandle">
        <template slot="otherBtn">
          <el-button v-if="submitAuth" type="primary" :disabled="!selection.length" @click="submit"> 提交</el-button>
          <el-button v-if="cancelAuth" type="primary" :disabled="!selection.length" @click="repeal"> 撤销</el-button>
          <el-button v-if="printAuth" type="primary" :disabled="!selection.length" @click="printOutStockOrder()">
            打印出库单
          </el-button>
          <el-button v-if="delAllAuth" type="danger" :disabled="!selection.length" @click="deleteBatch"> 批量删除
          </el-button>
        </template>
        <template slot="adSearch">
          <el-form
              :inline="true"
              :model="filter"
              label-width="65px"
              @submit.native.prevent
              @keyup.enter.native="loadData(1)">
            <el-form-item label="出库单号">
              <el-input v-model.trim="filter.billNo" placeholder="请输入出库单号" clearable/>
            </el-form-item>
            <el-form-item label="出库类型">
              <el-select v-model="filter.outStockType" clearable placeholder="请选择出库类型">
                <el-option label="销售出库" :value="0"/>
                <el-option label="仓库发料" :value="1"/>
                <el-option label="生产领料" :value="2"/>
                <el-option label="调拨出库" :value="3"/>
                <el-option label="委外出库" :value="4"/>
                <el-option label="退货出库" :value="5"/>
                <el-option label="盘亏出库" :value="6"/>
                <el-option label="自用出库" :value="7"/>
                <el-option label="工单发料" :value="8"/>
                <el-option label="反冲出库" :value="9"/>
                <el-option label="报废出库" :value="10"/>
                <el-option label="其他出库" :value="20"/>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="filter.status" clearable placeholder="请选择订单状态">
                <el-option label="草稿" :value="0"/>
                <el-option label="待确认" :value="1"/>
                <el-option label="已完成" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="关联单据">
              <el-input v-model.trim="filter.relBillNo" placeholder="请输入关联单据编号" clearable/>
            </el-form-item>
            <el-form-item label="制单人">
              <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="要求日期">
              <el-date-picker
                  v-model="requireDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('requireDateRange', 'requireDateBegin', 'requireDateEnd')"/>
            </el-form-item>
            <el-form-item label="制单日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
    </el-main>
    <out-stock-order-edit ref="editPage" @save-success="loadData(1)"/>
    <print-out-stock-order-modal ref="printOutStockOrder"/>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import OutStockOrderEdit from "./OutStockOrderEdit.vue";
  import PrintOutStockOrderModal from "./PrintOutStockOrder.vue";

  export default {
    name: "OutStockOrderList",
    components: {ViewTable, OutStockOrderEdit, PrintOutStockOrderModal},
    data() {
      return {
        limits: {
          addAuth: this.$auth(44),
          delAuth: this.$auth(51),
          editAuth: this.$auth(49),
        },
        submitAuth: this.$auth(45),
        cancelAuth: this.$auth(46),
        printAuth: this.$auth(47),
        delAllAuth: this.$auth(48),
        detailAuth: this.$auth(50),
        ids: [],
        selection: [],
        requireDateRange: [],
        createDateRange: [],
        searchShow: false,
        OutStorageDate: "", // 出库日期
        createDate: "", // 制单日期
        filter: {
          billNo: "",
          relBillNo: "",
          status: 1,
          outStockType: "",
          relBillId: "",
          requireDateBegin: "",
          requireDateEnd: "",
          createTimeBegin: "",
          createTimeEnd: "",
          creatorName: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        if (this.detailAuth) {
                          this.$refs.editPage.open(params.row, true);
                        }
                      },
                    },
                  },
                  params.row.billNo,
              );
            },
          },
          {
            key: "outStockTypeName",
            align: "center",
            width: 90,
          },
          {
            key: "relBillNo",
            align: "left",
            width: 150,
            tooltip: true,
          },
          {
            key: "statusName",
            align: "center",
            width: 80,
          },
          {
            key: "requireDate",
            align: "center",
            width: 160,
          },
          {
            key: "creatorName",
            align: "center",
            width: 100,
          },
          {
            key: "createTime",
            align: "center",
            width: 160,
          },
          {
            key: "note",
            align: "left",
            minWidth: 240,
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      "filter.requireDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.requireDateRange = [];
            this.requireDateRange.push(this.filter.requireDateBegin);
            this.requireDateRange.push(this.filter.requireDateEnd);
          }
        },
      },
      "filter.createTimeBegin": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createTimeBegin);
            this.createDateRange.push(this.filter.createTimeEnd);
          }
        },
      },
    },
    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        if (row) {
          if (row.status === 1 || row.status === 2) {
            this.$message.error("当前订单状态无法进行编辑");
            return;
          }
        }
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.ids = [];
        this.selection = selection;
        this.selection.forEach((item) => {
          this.ids.push(item.pkid);
        });
      },

      // 提交
      submit() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "outStockBills/submit", this.ids).then(() => {
              this.loadData(1);
              this.$message.success("提交成功");
              this.selection = [];
            });
          });
        }
      },

      // 撤销
      repeal() {
        const arr = this.selection.filter((item) => item.status !== 1);
        if (arr.length) {
          this.$confirm("请选择已提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "outStockBills/cancel", this.ids).then(() => {
              this.loadData(1);
              this.$message.success("撤销成功");
              this.selection = [];
            });
          });
        }
      },

      // 打印出库单
      printOutStockOrder() {
        const arr = this.selection.filter((item) => item.status == 0);
        if (arr.length) {
          this.$confirm("请选择已提交或已出库的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$refs.printOutStockOrder.open(this.ids);
      },

      // 单个删除
      deleteHandle(row) {
        if (row.status === 1 || row.status === 2) {
          this.$message.error("当前订单状态无法删除");
          return;
        }
        this.$http.delete("basic", "outStockBills", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      // 批量删除
      deleteBatch() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交状态的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "outStockBills/deleteBatch", this.ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
